// Max lengths mirrored from the API models:
// AiConsultationTemplateModel / AiTemplateSection / AiUserControl / AiConsultationAction,
// TreatmentPlanAppointment / TreatmentPlanTaskModel, PreConsultTemplateModel and
// AiTemplateGeneration. Keep in sync with the backend [MaxLength]/[SwaggerSchemaPattern].

export const CONSULTATION_TEMPLATE_LIMITS = {
  templateName: 500,
  consultationSummary: 500000,
  generationPrompt: 5000,
  sectionTitle: 500,
  questionLabel: 5000,
  actionLabel: 5000,
  appointmentName: 500,
  taskText: 500,
  reviewNote: 5000,
} as const;

export const PRE_CONSULT_TEMPLATE_LIMITS = {
  templateName: 500,
  generationPrompt: 5000,
  sectionTitle: 500,
  // API allows 5,000,000 for a question label; the UI keeps its stricter 5000.
  questionLabel: 5000,
  option: 100000,
  disclaimerText: 50000,
} as const;
